export enum GfGroupActionCategory {
  Engagement = 'engagement',
  Attendance = 'attendance',
  Acknowledgment = 'acknowledgment'
}

export enum GfGroupActionType {
  Text = 'text',
  Image = 'image',
}

export interface GfGroupAction {
  id: string;
  category: GfGroupActionCategory;
  type: GfGroupActionType;
  title: string;
  content: string;
  memberEngagementStatuses: string[];
}
